import getText from "vamos/cockpit/base/handler/Text";
import { ReleaseDto } from "vamos/cockpit/model/api/vamos.private.api.types";
import { RequestData } from "vamos/cockpit/main/app/message/model/RequestData";
import SupplierMessageData from "vamos/cockpit/main/app/message/model/SupplierMessageData";

export default class MessageHandler {

    public static handleMessageDescription(messageKey: string, replacementContent: string) {
        let textArgs;

        switch (messageKey) {
            case "REQUEST_EXTRACTION_ALREADY_EXTRACTED":
            case "REQUEST_EXTRACTION_REQUIREMENT_MADE_MISSES":
            case "REQUEST_EXTRACTION_REQUEST_NOT_EXISTS":
            case "REQUEST_EXTRACTION_NEGATIVE_VALUES":
            case "REQUEST_EXTRACTION_SUCCEED": {
                const content = JSON.parse(replacementContent) as RequestData;
                textArgs = [content.number];
                break;
            }
            case "RELEASE_NOTES":
                return getText("RELEASE_NOTE_DESCRIPTION");
            case "SUPPLIER_SERVER_CONNECTION_DISABLED": {
                const content = JSON.parse(replacementContent) as SupplierMessageData;
                return getText("SUPPLIER_SERVER_CONNECTION_DISABLED", [content.supplierName]);
            }
            default: {
                console.error(`${messageKey} is not a valid messageKey`);
                return "";
            }
        }
        return getText(`MSG_${messageKey}`, textArgs);
    }

    public static handleMessageTitle(type: string, replacementContent: string) {
        switch (type) {
            case "ORDER_WITHDRAWAL":
                return getText("ORDER_WITHDRAWAL");
            case "RELEASE_NOTE": {
                const content = JSON.parse(replacementContent) as ReleaseDto;
                return getText("RELEASE_NOTE", [content.version]);
            }
            case "SUPPLIER_SERVER_CONNECTION_FAILURE":
                return getText("SUPPLIER_SERVER_CONNECTION_FAILURE");

            default:
        }
    }

    public static handleButtonText(type: string) {
        switch (type) {
            case "ORDER_WITHDRAWAL":
                return getText("ShowRequest");
            case "RELEASE_NOTE": {
                return getText("SHOW_RELEASE_DETAILS");
            }
            case "SUPPLIER_SERVER_CONNECTION_FAILURE": {
                return getText("SHOW_SUPPLIER_DETAILS");
            }
            default:
                console.error(`${type} is not a valid type`);
                return "";
        }
    }

}